export default {
	timer_active: ' aktiv',
	timer_active_title: 'Aktive Timer',
	timer_add_favorite: 'Als Favorit hinzufügen',
	timer_add_favorites_title: 'Weitere Favoriten Konfigurieren',
	timer_appointment_rounding_label: 'Schrittweite',
	timer_appointment_title_label: 'Termintitel:',
	timer_appointment_type_label: 'Termintyp:',
	timer_btn_start: 'Timer starten',
	timer_btn_stop_all: 'Alle stoppen',
	timer_click_to_start: '→ Klicken zum Starten',
	timer_dialog_title: 'Zeiterfassung',
	timer_favorite_tooltip_click_to_start: 'Klicken zum Starten',
	timer_favorites_title: 'Favoriten',
	timer_manual_start: 'Timer manuell starten',
	timer_no_active_description: 'Starte einen neuen Timer oben',
	timer_no_active_title: 'Keine aktiven Timer',
	timer_no_favorites: 'Sie haben keine Favoriten Konfiguriert',
	timer_open_appointment_details: 'Termindetails anzeigen',
	timer_quickstart_description: 'Zuletzt verwendete Termintypen',
	timer_quickstart_no_recent_list: 'Noch keine kürzlichen Timer',
	timer_remove_favorite: 'Favorit entfernen',
	timer_rename: 'Umbenennen',
	timer_rounding_minutes_label: 'Schrittweite:',
	timer_select_appontmentType: 'Termintyp auswählen',
	timer_select_no_options: 'Keine Optionen verfügbar',
	timer_select_rounding_title: 'Terminschrittweite auswählen',
	timer_start: 'Timer starten',
	timer_started: 'Gestartet: ',
	timer_stop: 'Timer stoppen',
	timer_title: 'Timer starten & verwalten',
	timer_tooltip_start: 'Timer starten',
	timer_tooltip_stop: 'Timer stoppen',
};
